<template>
    <div>
        <div class="task-component-content"
            :style="getAllTaskComponentContent"
            @click="rePortTaskComponent()">
            <div>
                <!-- 组件任务顶部背景图片 -->
                <img class="task-image-top"
                    :style="getTopImgStyle"
                    :src="getPicUrl(activityComponentObj && activityComponentObj.jsonField && activityComponentObj.jsonField.themePic)">
                <div class="task-content-parent"
                    :style="getAllTaskContentStyle">
                    <div v-for="item in activityComponentObj.componentDetailVOlList"
                        :key="item.index"
                        class="task-content"
                        :style="everyTaskStyle">
                        <div class="task-left">
                            <img class="task-image"
                                :src="getTaskIconUrl(item.taskIconUrl)">
                        </div>
                        <div class="task-right">
                            <div class="task-title"
                                :style="getTitleStyle">{{item.taskTitle}}</div>
                            <!-- 普通任务副标题，说明文字 -->
                            <template v-if="item.taskType === TASK_TYPE.GENERAL_TASK">
                                <div v-if="item.userTaskStatus === TASK_STATUS.GENERAL_NOT_MEET_REQUIREMENTS"
                                    class="task-desc"
                                    :style="getDescStyle">您已添加导购，去邀请好友赢抽奖机会吧</div>
                                <div v-else
                                    class="task-desc"
                                    :style="getDescStyle">{{ item.taskDescription }}</div>
                            </template>
                            <!-- 邀请任务副标题，说明文字 -->
                            <div v-else
                                class="task-desc"
                                :style="getDescStyle">
                                每邀请{{ item.eachInvitationNumber }}人送{{ item.eachLotteryNumber }}次抽奖机会，邀请上限{{ item.invitationMaxNumber }}人，已邀请成功{{ item.usedNumber }}人，已获得{{ item.drawUesdNumber }}次抽奖机会
                            </div>
                            <div class="task-btn-parent">
                                <!-- 普通任务按钮 -->
                                <template v-if="item.taskType === TASK_TYPE.GENERAL_TASK">
                                    <!-- 0 普通任务进行中，未完成 -->
                                    <van-button v-if="item.userTaskStatus === TASK_STATUS.GENERAL_STARTED_NOT_COMPLETED"
                                        class="task-btn"
                                        :style="getBtnStyle"
                                        @click="goToAdd(item)">去添加</van-button>
                                    <!-- 1 普通任务进行中，已完成 -->
                                    <van-button v-else-if="item.userTaskStatus === TASK_STATUS.GENERAL_STARTED_COMPLETED"
                                        class="task-btn"
                                        :style="getBtnStyle"
                                        @click="clickGoDraw(item,'goDraw')">去抽奖</van-button>
                                    <!-- 5：普通任务已结束，已参与 -->
                                    <van-button v-else-if="item.userTaskStatus === TASK_STATUS.GENERAL_ENDED_COMPLETED"
                                        class="task-btn"
                                        :style="getBtnStyle"
                                        @click="clickGoDraw(item)">去查看</van-button>
                                    <!-- 2 普通任务未开始 3：普通任务已结束，未参与 4：不符合条件，例如以前已经加了好友，不能再加了-->
                                    <van-button v-else
                                        class="task-btn"
                                        :style="getBtnStyle"
                                        disabled>去添加</van-button>
                                </template>
                                <!-- 邀请任务按钮 -->
                                <template v-if="item.taskType === TASK_TYPE.INVITATION_TASK">
                                    <!-- 10 邀请任务进行中，未邀请 15 邀请任务进行中，已邀请，但无抽奖机会-->
                                    <van-button
                                        v-if="item.userTaskStatus === TASK_STATUS.INVITATION_STARTED_NOT_INVITED || item.userTaskStatus === TASK_STATUS.INVITATION_STARTED_INVITED_NO_CHANCES"
                                        class="task-btn"
                                        :style="getBtnStyle"
                                        @click="generateInvitationPoster(item)">去邀请</van-button>
                                    <!-- 11 邀请任务进行中，已完成 12 邀请任务进行中，有抽奖机会-->
                                    <template
                                        v-else-if="item.userTaskStatus === TASK_STATUS.INVITATION_STARTED_COMPLETED || item.userTaskStatus === TASK_STATUS.INVITATION_STARTED_HAS_CHANCES">
                                        <van-button class="task-btn"
                                            :style="getBtnStyle"
                                            @click="generateInvitationPoster(item)">去邀请</van-button>
                                        <van-button class="task-btn"
                                            :style="getBtnStyle"
                                            @click="clickGoDraw(item,'goDraw')">去抽奖</van-button>
                                    </template>
                                    <!-- 16 邀请任务已结束，已邀请，有抽奖机会 -->
                                    <template v-else-if="item.userTaskStatus === TASK_STATUS.INVITATION_ENDED_INVITED_HAS_CHANCES">
                                        <van-button class="task-btn"
                                            :style="getBtnStyle"
                                            disabled>去邀请</van-button>
                                        <van-button class="task-btn"
                                            :style="getBtnStyle"
                                            @click="clickGoDraw(item)">去查看</van-button>
                                    </template>
                                    <!-- 13 邀请任务未开始 14 邀请任务已结束，未邀请 17 邀请任务已结束，已邀请，无抽奖机会-->
                                    <van-button v-else
                                        class="task-btn"
                                        :style="getBtnStyle"
                                        disabled>去邀请</van-button>
                                    <!-- 邀请明细按钮 -->
                                    <van-button v-if="item.userListFlag"
                                        class="task-btn"
                                        :style="getBtnStyle"
                                        @click="goBoostDetail(item)">邀请明细</van-button>
                                </template>
                            </div>
                        </div>
                        <!-- 右上角图标 -->
                        <div v-if="getRightIcon(item)"
                            class="right-top-icon">
                            <img class="right-top-icon-img"
                                :src="getRightIcon(item)">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 分享海报 -->
        <invite-poster ref="invitePoster"></invite-poster>
    </div>

</template>

<script>
import wx from 'weixin-js-sdk';
import utils from '../../../../utils/comUtils.js';
import { TASK_STATUS, TASK_TYPE } from '../../../../commons/commonVariables.js';
import InvitePoster from '../activity-boost/invite-poster.vue';
import { Toast } from 'vant';
import { checkActivityStatus } from '../common-methods/utils.js';
export default {
  components: { Toast, InvitePoster },
  props: {
    activityComponentObj: {
      type: Object,
      default: () => {
        return {};
      },
    },
    activityCode: {
      type: String,
      default: '',
    },
    // 是否登录
    isLoginFlag: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      TASK_STATUS: TASK_STATUS,
      TASK_TYPE: TASK_TYPE,
    };
  },
  created() {
    this.activityUrl = `${window.location.origin}/hd/hdmain?activityCode=${this.activityCode}`;
    // 获取和拼接当前url
  },
  computed: {
    getAllTaskComponentContent() {
      const json = (this.activityComponentObj && this.activityComponentObj.jsonField) || {};
      return {
        'padding-top': json.componentTopMargin ? json.componentTopMargin + 'px' : '10px',
      };
    },
    getAllTaskContentStyle() {
      const json = (this.activityComponentObj && this.activityComponentObj.jsonField) || {};
      return {
        'background-image':
          `linear-gradient(to bottom, ${json.componentBackgroundValueStart}, ${json.componentBackgroundValueEnd})` ||
          'linear-gradient(to bottom, #D6E6EE, #FAFAFC)',
      };
    },
    // 任务组件头部图片样式，其实就是左上右上圆角大小
    getTopImgStyle() {
      const json = (this.activityComponentObj && this.activityComponentObj.jsonField) || {};
      return {
        'border-top-left-radius': json.componentRadius ? json.componentRadius + 'px' : '16px',
        'border-top-right-radius': json.componentRadius ? json.componentRadius + 'px' : '16px',
      };
    },
    everyTaskStyle() {
      const json = (this.activityComponentObj && this.activityComponentObj.jsonField) || {};
      return {
        'border-radius': json.taskRadius ? json.taskRadius + 'px' : '12px',
        'background-color': json.listBackgroundColor || '#FFFFFF',
      };
    },
    getTitleStyle() {
      const json = (this.activityComponentObj && this.activityComponentObj.jsonField) || {};
      return {
        color: json.nameColor || '#3D3D3D',
      };
    },
    getDescStyle() {
      const json = (this.activityComponentObj && this.activityComponentObj.jsonField) || {};
      return {
        color: json.descColor || '#999999',
      };
    },
    getBtnStyle() {
      const json = (this.activityComponentObj && this.activityComponentObj.jsonField) || {};
      return {
        color: json.btnTextColor || '#FFFFFF',
        'background-image': `linear-gradient(to bottom, ${json.btnStartColor}, ${json.btnEndColor})` || 'linear-gradient(to bottom, #0199E2, #0199E2)',
      };
    },
  },
  methods: {
    /**
     * 任务状态
     * 0：未跟进（邀请：去邀请：普通：去添加）
     * 1：已完成（已完成，去抽奖))
     * 2.跟进中（展示去邀请，去抽奖）
     * 3.未开始（邀请：去邀请：普通：去添加）
     * 4.已结束（去查看）
     */
    getBtnTextFirst(item) {
      let btnText = '';
      if (item.userTaskStatus === this.TASK_STATUS.NOT_FOLLOWED_UP) {
        if (item.taskType === this.TASK_TYPE.GENERAL_TASK) {
          btnText = '去添加';
        } else {
          btnText = '去邀请';
        }
      } else if (item.userTaskStatus === this.TASK_STATUS.COMPLETED) {
        btnText = '去抽奖';
      } else if (item.userTaskStatus === this.TASK_STATUS.IN_PROGRESS) {
        btnText = '去邀请';
      } else if (item.userTaskStatus === this.TASK_STATUS.NOT_STARTED) {
        if (item.taskType === this.TASK_TYPE.GENERAL_TASK) {
          btnText = '去添加';
        } else {
          btnText = '去邀请';
        }
      } else if (item.userTaskStatus === this.TASK_STATUS.ENDED) {
        btnText = '去查看';
      }
      return btnText;
    },
    /**
     * generalTask: 普通任务
     * invitationTask: 邀请任务
     * magicActivity: 活动管理-邀请有礼
     * aggregationCodeId: 聚合二维码id
     */
    // 跳转到小程序

    goToMiniPage(item) {
      console.log('判断是否需登录-this.isLoginFlag', this.isLoginFlag);
      // 没有登录拉起登录
      if (!this.isLoginFlag) {
        Toast('请先登录！');
        return;
      }
      // 0：未跟进（邀请：去邀请：普通：去添加，说明任务已经开始不置灰）
      if (item.userTaskStatus === this.TASK_STATUS.NOT_FOLLOWED_UP) {
        // 普通任务
        if (item.taskType === this.TASK_TYPE.GENERAL_TASK) {
          if (this.isLoginFlag) {
            wx.miniProgram.navigateTo({
              url: `/subpackages/activity/pages/nearShoppers/add-shopper?taskType=generalTask&endId=magicActivity&aggregationCodeId=${
                item.qywechatQrId
              }&activityCode=${this.activityCode}&taskCode=${item.taskCode}&activityUrl=${encodeURIComponent(this.activityUrl)}`,
            });
          }
          this.rePortGoAdd(item);
        } else {
          // 邀请任务
          this.rePortGoInvitation(item);
        }
      } else if (item.userTaskStatus === this.TASK_STATUS.COMPLETED) {
        // 1：已完成（已完成，去抽奖)
        this.reportGoDraw(item);
        this.goJumpDraw(item);
      } else if (item.userTaskStatus === this.TASK_STATUS.IN_PROGRESS) {
        // 2.跟进中（展示去邀请，去抽奖）
        this.rePortGoInvitation(item);
      } else if (item.userTaskStatus === this.TASK_STATUS.ENDED) {
        // 4.已结束（展示去查看）
        this.rePortGoView(item);
        this.goJumpDraw(item);
      }
    },
    async goToAdd(item) {
      console.log('判断是否需登录-this.isLoginFlag', this.isLoginFlag);
      // 没有登录拉起登录
      if (!this.isLoginFlag) {
        Toast('请先登录！');
        return;
      }
      const getActivityStatus = await checkActivityStatus(item.taskCode, this.activityCode, '', this);
      if (!getActivityStatus) {
        return;
      }
      wx.miniProgram.navigateTo({
        url: `/subpackages/activity/pages/nearShoppers/add-shopper?taskType=generalTask&endId=magicActivity&aggregationCodeId=${
          item.qywechatQrId
        }&activityCode=${this.activityCode}&taskCode=${item.taskCode}&activityUrl=${encodeURIComponent(this.activityUrl)}`,
      });
      this.rePortGoAdd(item);
    },
    goJumpDraw(item) {
      this.$router.push({
        path: `/hdmain?activityCode=${item.activityMainCode}`,
      });
    },
    clickGoDraw(item, event) {
      if (event && event === 'goDraw') {
        this.reportGoDraw(item);
      }
      this.goJumpDraw(item);
    },
    reportGoDraw(item) {
      const params = {
        actionCode: '400070008',
        actionName: '点击去抽奖',
        title: '点击去抽奖',
        taskCode: item.taskCode,
      };
      this.goBatchReport(params);
    },
    rePortGoInvitation(item) {
      const params = {
        actionCode: '400070007',
        actionName: '点击去邀请',
        title: '点击去邀请',
        taskCode: item.taskCode,
      };
      this.goBatchReport(params);
    },
    rePortGoAdd(item) {
      const params = {
        actionCode: '400070006',
        actionName: '点击去添加',
        title: '点击去添加',
        taskCode: item.taskCode,
      };
      this.goBatchReport(params);
    },
    rePortTaskComponent() {
      const params = {
        actionCode: '400070003',
        actionName: '点击任务控件',
        title: '点击任务控件',
      };
      this.goBatchReport(params);
    },
    rePortGoView(item) {
      const params = {
        actionCode: '400070009',
        actionName: '点击去查看',
        title: '点击去查看',
        taskCode: item.taskCode,
      };
      this.goBatchReport(params);
    },
    goBatchReport(data) {
      const params = {
        actionCode: data.actionCode,
        actionName: data.actionName,
        content: {
          title: data.title,
          activityCode: this.activityCode,
          taskCode: data.taskCode || '',
        },
      };
      console.log('上报参数', params);
      utils.handleBatchReport(this, params);
    },
    // 获取图片地址
    getPicUrl(data) {
      if (data) {
        return this.$utils.getImageUrl(JSON.parse(data).file);
      }
    },
    getTaskIconUrl(file) {
      if (file) {
        return this.$utils.getImageUrl(file);
      }
    },

    // 任务右上角添加状态图标
    getRightIcon(item) {
      if (item.taskType === TASK_TYPE.GENERAL_TASK) {
        if (item.userTaskStatus === this.TASK_STATUS.GENERAL_NOT_STARTED) {
          return require('../../../../../static/image/activityManage/notStart.svg');
        } else if (item.userTaskStatus === this.TASK_STATUS.GENERAL_STARTED_COMPLETED || item.userTaskStatus === this.TASK_STATUS.GENERAL_ENDED_COMPLETED) {
          return require('../../../../../static/image/activityManage/completed.svg');
        } else if (item.userTaskStatus === this.TASK_STATUS.GENERAL_ENDED_NOT_COMPLETED) {
          return require('../../../../../static/image/activityManage/ended.svg');
        }
      } else {
        if (item.userTaskStatus === this.TASK_STATUS.INVITATION_NOT_STARTED) {
          return require('../../../../../static/image/activityManage/notStart.svg');
        } else if (item.userTaskStatus === this.TASK_STATUS.INVITATION_STARTED_COMPLETED) {
          return require('../../../../../static/image/activityManage/completed.svg');
        } else if (
          item.userTaskStatus === this.TASK_STATUS.INVITATION_ENDED_NOT_INVITED ||
          item.userTaskStatus === this.TASK_STATUS.INVITATION_ENDED_INVITED_HAS_CHANCES ||
          item.userTaskStatus === this.TASK_STATUS.INVITATION_ENDED_INVITED_NO_CHANCES
        ) {
          return require('../../../../../static/image/activityManage/ended.svg');
        }
      }
    },
    goBoostDetail(item) {
      // 跳转邀请明细页
      this.$router.push({
        path: `/activityBoostDetail?activityCode=${this.activityCode}&taskCode=${item.taskCode}`,
      });
    },
    // 生成邀请海报
    async generateInvitationPoster(item) {
      // 没有登录拉起登录
      if (!this.isLoginFlag) {
        Toast('请先登录！');
        return;
      }
      const getActivityStatus = await checkActivityStatus(item.taskCode, this.activityCode, '', this);
      if (!getActivityStatus) {
        return;
      }
      if (item.sharePosterImage) {
        // 生成分享Id
        this.$api.post({
          sc: 'mobileMarketingH5',
          url: `activityTask/share`,
          params: {
            activityCode: this.activityCode,
            taskCode: item.taskCode,
          },
          success: (res) => {
            if (res.code === 200 && res.result) {
              const posterInfo = {
                posterBg: this.$utils.getImageUrl(item.sharePosterImage),
                qrUrl: res.result,
              };
              this.$refs.invitePoster.openPopup(posterInfo);
            } else {
              Toast('海报生成失败，请稍后再试~');
            }
          },
          fail: (err) => {
            Toast('海报生成失败，请稍后再试~');
            console.log('获取分享Id失败', err);
          },
        });
      } else {
        Toast('海报生成失败，请稍后再试~');
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.task-component-content {
  overflow: hidden;
}
.task-content-parent {
  padding: 0 10px;
  width: calc(100% - 20px);
  margin-left: auto;
  margin-right: auto;
  background-image: linear-gradient(to bottom, rgb(214, 230, 238), rgb(250, 250, 252));
  padding-bottom: 10px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}
.task-content {
  display: flex;
  margin-bottom: 10px;
  align-items: center;
  padding: 1.333vw 1.333vw 1.333vw 2.133vw;
  position: relative;
}
.right-top-icon {
  position: absolute;
  width: 50px;
  height: 42px;
  right: 2.46px;
  top: 4px;
}
.right-top-icon-img {
  width: 100%;
  height: 100%;
}
/* 确保最后一个task-content元素没有margin-bottom */
.task-content:last-child {
  margin-bottom: 0px;
}
.task-left {
  width: 60px;
  height: 60px;
  background-color: #eee;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 14px;
  margin-right: 1.333vw;
}
.task-right {
  flex: 1;
}
.task-image {
  width: 100%;
  height: 100%;
}
.task-image-top {
  width: calc(100% - 20px);
  display: block;
  margin-right: auto;
  margin-left: auto;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.task-btn {
  width: 62px;
  height: 26px;
  font-size: 12px;
  background: #0066ff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  color: #ffffff;
  padding: 0;
  border: none;
}
.task-desc {
  margin-bottom: 12px;
  font-size: 12px;
  color: #999999;
}
.task-title {
  margin-bottom: 3px;
  font-size: 16px;
  color: #3d3d3d;
}
.task-btn-parent {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 20px;
}
</style>


// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/activityManagementComponents/taskComponent.vue